module.exports = __webpack_public_path__ + "static/media/mode-71.1354a184.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-71.svg
// module id = 1023
// module chunks = 2